/**
 * 菜单类型，路由类型
 * @param Grid 1 报表
 * @param Form 2 表格
 * @param CustomPage 3 自定义页面
 * @param Chart 4 图表
 * @param ToDoTask 5 我的待办
 * @param OwnerTask 6 我发起的
 * @param ParticipateTask 7 我参与的
 * @param CCTask 8 抄送我的
 */
enum MenuType {
    /**
     * 报表
     */
    Grid = 1,
    /**
     * 表格
     */
    Form = 2,
    /**
     * 自定义页面
     */
    CustomPage = 3,
    /**
     * 图表
     */
    Chart = 4,
    /**
     * 我的待办
     */
    ToDoTask = 5,
    /**
     * 我发起的
     */
    OwnerTask = 6,
    /**
     * 我参与的
     */
    ParticipateTask = 7,
    /**
     * 抄送我的
     */
    CCTask = 8
}

type SiteModule = {
    ModuleName:string,  
    ModuleId:string,
    IconClass:string
}

type MenuItem = {
    Path:string,
    CurrentModule:string,
    DisplayName:string
}

type MenuViewModel = {
    Modules:Array<SiteModule>,
    MenuItems:Array<ModuleMenus>
}

type ModuleMenus = {
    ModuleId:string,
    Menus:Array<Object>
}

type MenuItemResult = {
    ConnectId:string,
    AdminMenuType:MenuType,
    DisplayName:string,
    IconClass:string,
    IsLeaf:boolean,
    Children:Array<MenuItem>
}

let RoutePathBuilder = function(menuItem : MenuItemResult){
    let result = "";
    switch (menuItem.AdminMenuType) {
        case MenuType.Grid:
            result = "/grid/" + menuItem.ConnectId;
            break;
        case MenuType.CustomPage:
            result = "/customPage/" + menuItem.ConnectId;
            break;
        case MenuType.Form:
            result = "/form/" + menuItem.ConnectId;
            break;
        case MenuType.Chart:
            result = "/chart/" + menuItem.ConnectId;
            break;
        case MenuType.ToDoTask:
            result = "/task/todo";
            break;
        case MenuType.OwnerTask:
            result = "/task/owner";
            break;
        case MenuType.ParticipateTask:
            result = "/task/participate";
            break;
        case MenuType.CCTask:
            result = "/task/cCTask";
        default:
            result = "/";
            break;
    }
    return result;
}

export { MenuType, SiteModule, MenuItem, MenuViewModel, ModuleMenus, RoutePathBuilder }